'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _noImagePanel = require('../../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _imageHeadline = require('../../../../molecules/image-headline');

var _imageHeadline2 = _interopRequireDefault(_imageHeadline);

var _accordion = require('../../../../organisms/accordion');

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _themeManager = require('./../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _moleculesMap = require('./../../utilities/moleculesMap');

var _moleculesMap2 = _interopRequireDefault(_moleculesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Organism Imports

// Molecule Imports


// Utilities Imports


var ORGANISM_NAME = 'simple-panels-accordion';

var SimplePanelsAccordion = function (_React$Component) {
  _inherits(SimplePanelsAccordion, _React$Component);

  function SimplePanelsAccordion(props) {
    _classCallCheck(this, SimplePanelsAccordion);

    var _this = _possibleConstructorReturn(this, (SimplePanelsAccordion.__proto__ || Object.getPrototypeOf(SimplePanelsAccordion)).call(this, props));

    _this.handleOpenItem = _this.handleOpenItem.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);

    _this.state = {
      isMobile: false
    };

    _this.moleculesMap = _moleculesMap2.default;
    return _this;
  }

  _createClass(SimplePanelsAccordion, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      // TODO: Explore different solution to trigger resize
      // inside an iFrame; We don't need this event
      // param; it's only for page-builder
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'handleOpenItem',
    value: function handleOpenItem(items) {
      if (this.props.onOpenItem) {
        this.props.onOpenItem(items);
      }

      this.forceUpdate();
    }
  }, {
    key: 'renderPanels',
    value: function renderPanels(items) {
      var _this2 = this;

      if (items) {
        return items.map(function (properties, idx) {
          var type = _this2.props.config.type || properties.config.type || 'NoImagePanel';
          var newProps = (0, _themeManager2.default)(properties, _this2.props.config.theme);
          var Panel = _this2.moleculesMap[type];
          return _react2.default.createElement(Panel, _extends({}, newProps, { name: 'PnlAccdn', key: idx }));
        });
      }
      return null;
    }
  }, {
    key: 'renderAccordionItemHeader',
    value: function renderAccordionItemHeader(item) {
      if (item) {
        var filteredProps = (0, _clone2.default)(item);
        // Translating to image to re-use molecule;
        // TODO: Remove this once we figure a better solution
        // on preserving the content on PB.
        filteredProps.content.image = filteredProps.content.icon;
        // Deleting Image from the accordion header (but icon is supported)
        if ((this.props.config.type || filteredProps.config.type) !== 'IconPanel') {
          filteredProps.content.image = null;
        }

        return _react2.default.createElement(
          _accordion.AccordionHeader,
          null,
          _react2.default.createElement(_imageHeadline2.default, filteredProps)
        );
      }
      return null;
    }
  }, {
    key: 'renderAccordionItemContent',
    value: function renderAccordionItemContent(item, idx) {
      if (item) {
        var type = this.props.config.type || item.config.type || 'NoImagePanel';
        var Panel = this.moleculesMap[type];
        var newProps = (0, _themeManager2.default)(item, this.props.config.theme);
        newProps.content.image = null;
        newProps.content.icon = null;
        newProps.content.headline = null;
        newProps.idx = idx;
        return _react2.default.createElement(
          _accordion.AccordionContent,
          null,
          _react2.default.createElement(Panel, _extends({}, newProps, { name: 'PnlAccdn', pnlIdx: idx }))
        );
      }
      return null;
    }
  }, {
    key: 'renderAccordion',
    value: function renderAccordion(items) {
      var _this3 = this;

      if (items) {
        var accordionItems = items.map(function (item, idx) {
          return _react2.default.createElement(
            _accordion.AccordionItem,
            { key: idx },
            _this3.renderAccordionItemHeader(item),
            _this3.renderAccordionItemContent(item, idx)
          );
        });
        return _react2.default.createElement(
          _accordion.Accordion,
          { onItemOpen: this.handleOpenItem },
          accordionItems
        );
      }
      return null;
    }
  }, {
    key: 'renderByViewPort',
    value: function renderByViewPort(isMobile) {
      var content = this.props.content;
      var items = content.items;


      if (isMobile) {
        return this.renderAccordion(items);
      }
      return this.renderPanels(items);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      var sectionClassName = (0, _classnames2.default)(ORGANISM_NAME, className);
      return _react2.default.createElement(
        _Panels2.default,
        _extends({}, this.props, { className: sectionClassName }),
        this.renderByViewPort(this.state.isMobile)
      );
    }
  }]);

  return SimplePanelsAccordion;
}(_react2.default.Component);

exports.default = SimplePanelsAccordion;


SimplePanelsAccordion.propTypes = _Panels2.default.propTypes;

var items = [_noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps];
SimplePanelsAccordion.defaultProps = (0, _clone2.default)(_Panels2.default.defaultProps);
SimplePanelsAccordion.defaultProps.content.items = items;
SimplePanelsAccordion.defaultProps.config.type = 'NoImagePanel';


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/simple-panels-accordion/jsx/SimplePanelsAccordion.js
// module id = 689
// module chunks = 4